import urls from "../../../../global/constants/UrlConstants";
import {
  getCallParams,
  getNoAuthCallParams,
  makeCall,
} from "../../../../utils/service";

export async function RegisterEmployee(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.REGISTEREMPLOYEE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getPerosnalDetails(userId: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEERECORDBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updatePersonalDetail(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(
      urls.UPDATEEMPLOYEEPERSONALDETAIL,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateOfficailInfo(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(
      urls.UPDATEEMPLOYEEOFFICIALDETAIL,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getOfficeDetails(userId: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEEOFFICEDETAILBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getBankDetails(userId: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEEBANKDETAILBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateLeaveInfo(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEEMPLOYEELEAVEINFO, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateBankInfo(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEEMPLOYEEBANKINFO, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getLeaveDetail(userId: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEELEAVEDETAILBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function saveOfficialInfo(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDUSEROFFICE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function saveBankDetails(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.SAVEEMPLOYEEBANKINFO, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function saveLeaveDetails(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.SAVEEMPLOYEEBANKDETAILS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getSalaryDetail(userId: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEESALARYDETAILBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateSalaryInfo(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEEMPLOYEESALARYINFO, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function saveSalaryDetails(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.SAVEEMPLOYEESALARYDETAILS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function addAdditionalDetail(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDALLPROPERTYLIST, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function updateAdditionalDetail(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEALLPROPERTYLIST, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

////////////////////////////////////////////////////////////////////////////////////////
export async function getDeveloper(country?:any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETALLDEVELOPER}?country=${country || ""}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getProjectByDeveloper(id?: String) {
  try {
    const callParams = await getCallParams("GET");
  
      const response = await makeCall(
        `${urls.GETALLPROJECT}?developerId=${id}&portalsOnly=0`,
        callParams
      );
      return response;
    
  } catch (error) {
    throw error;
  }
}

export async function getProject(id?: String) {
  try {
    const callParams = await getCallParams("GET");
    if (id && id != "") {
      const response = await makeCall(urls.GETPROJECTBYID + id, callParams);
      return response;
    } else {
      const response = await makeCall(
        `${urls.GETALLPROJECT}?portalsOnly=0`,
        callParams
      );
      return response;
    }
  } catch (error) {
    throw error;
  }
}

/** CRM project master list (includes inactive website details) with optional search. */
export async function searchProjects(params?: {
  search?: string;
  page?: number;
  limit?: number;
  organizationId?: string;
}) {
  try {
    const callParams = await getCallParams("GET");
    const qs = new URLSearchParams({
      portalsOnly: "0",
      page: String(params?.page ?? 0),
      limit: String(params?.limit ?? 500),
      search: String(params?.search ?? "").trim(),
    });
    const orgId = params?.organizationId;
    if (orgId && orgId !== "all" && orgId !== "*") {
      qs.set("organizationId", String(orgId));
    }
    return await makeCall(`${urls.GETALLPROJECT}?${qs.toString()}`, callParams);
  } catch (error) {
    throw error;
  }
}

export async function getPropetyFor() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLPROPERTYFOR, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getPropetyValuesList(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETALLPROPERTYLIST}/${id} `,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getPropetyType() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLPROPERTYTYPE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getPropetyUnitType(id?: String) {
  try {
    const callParams = await getCallParams("GET");
    if (id && id != "") {
      const response = await makeCall(
        urls.GETPROPERTYUNITTYPEBYID + id,
        callParams
      );
      return response;
    } else {
      const response = await makeCall(urls.GETALLPROPERTYUNITTYPE, callParams);
      return response;
    }
  } catch (error) {
    throw error;
  }
}

export async function getPropetyStatus(id?: String) {
  try {
    const callParams = await getCallParams("GET");
    if (id && id != "") {
      const response = await makeCall(
        urls.GETPROPERTYSTATUSBYID + id,
        callParams
      );
      return response;
    } else {
      const response = await makeCall(urls.GETALLPROPERTYSTATUS, callParams);
      return response;
    }
  } catch (error) {
    throw error;
  }
}

export async function addDeveloper(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDDEVELOPER, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addProject(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDPROJECT, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateProjectDetail(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEPROJECTDETAILS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addProjectDetail(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDPROJECTDETAILS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getProjectDetails(userId?: String) {
  const callParams = await getCallParams("GET");
  if (!userId) {
    return makeCall(urls.GETPROJECTLIST, callParams);
  }

  try {
    // Correct route: GET /getProjectDetailById/:id
    const byId = await makeCall(urls.GETPROJECTLISTBYID + userId, callParams);
    if (byId?.success !== 0 && byId?.data) {
      const raw = byId.data;
      const data = Array.isArray(raw) ? raw[0] : raw;
      if (data) return { ...byId, success: 1, data };
    }

    return {
      success: 0,
      data: null,
      message: byId?.message || "Project detail not found",
    };
  } catch (error: any) {
    // Soft-fail so edit UI can still use cached list-row data
    return {
      success: 0,
      data: null,
      message:
        typeof error?.message === "string"
          ? error.message
          : "Project detail not found",
    };
  }
}
// export async function getProjectDetails(payload:any) {
//   try {
//     const callParams = await getCallParams("GET");
//     const response = await makeCall(
//       `${urls.GETPROJECTLIST}?page=${payload.pageNumber}&limit=${payload.pageSize}`,
//       callParams
//     );
//     return response;
//   } catch (error) {
//     throw error;
//   }
// }

export async function uploadImage(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.UPLOADIMAGE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function uploadProductImage(body: any,name:any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(`${urls.UPLOADPRODUCTIMAGE}/${name}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDeveloperTree(id?: String) {
  try {
    const callParams = await getCallParams("GET");
    if (id && id != "") {
      const response = await makeCall(
        urls.GETDEVELOPERTREEBYID + id,
        callParams
      );
      return response;
    } else {
      const response = await makeCall(urls.GETDEVELOPERTREE, callParams);
      return response;
    }
  } catch (error) {
    // throw error;
  }
}


export async function getDeveloperTreeSerch(payload: any){
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETDEVELOPERTREE +
      
        `?search=${payload.search || ""}&page=${payload.pageNo}&limit=${payload.pageSize}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }

}





export async function addPropetyStatus(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GETAddPROPERTYSTATUS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function updateProject(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEPROJECTNAME, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function updateDeveloper(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEDEVELOPERNAME, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updatePropetyStatus(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.GETUPDATEPROPERTYSTATUS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addPropetyUnitType(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GETADDPROPERTYUNITTYPE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updatePropetyUnitType(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.GETUPDATEPROPERTYUNITTYPE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addPropetyType(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GETADDPROPERTYTYPE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updatePropetyType(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.GETUPDATEPROPERTYTYPE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addPropetyFor(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GETADDPROPERTYFOR, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updatePropetyFor(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.GETUPDATEPROPERTYFOR, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
